import { useMemo } from 'react';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useModelByEnvironment } from '@/hooks/discovery/model';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import { useEnvironmentScope } from '../useEnvironmentScope';

export const useModel = (
  uniqueId: ParsedUniqueId | undefined,
  environmentId?: number,
) => {
  const { environmentId: environmentIdFromUrl } = useDbtCloudProject();
  const { userId } = useEnvironmentScope();

  const [{ fetching, error, data }] = useModelByEnvironment({
    environmentId: environmentId ?? environmentIdFromUrl,
    userId,
    uniqueId: uniqueId?.raw || '',
    pause: uniqueId?.resourceType !== 'model',
  });

  const modelQuery = useMemo(() => {
    const appliedEdge = data?.environment.applied?.models.edges?.[0];
    return {
      fetching,
      error,
      data: {
        latestGitSha: data?.environment.applied?.latestGitSha,
        applied: appliedEdge?.node,
        adapterType: data?.environment.adapterType,
        modelQueryHistoryState: data?.environment.modelQueryHistoryState,
      },
    };
  }, [fetching, error, data]);
  return modelQuery;
};
